"use strict";
exports.__esModule = true;
exports.chart_color_green_100 = {
  "name": "--pf-v5-chart-color-green-100",
  "value": "#bde2b9",
  "var": "var(--pf-v5-chart-color-green-100, #bde2b9)"
};
exports["default"] = exports.chart_color_green_100;